<template>
  <div class="modal fade" :id="modalId" ref="addVacModalEl" tabindex="-1" :aria-labelledby="`${modalId}-label`" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title" :id="`${modalId}-label`">{{modalTitle}}</div>
        <button class="btn btn-default btn-sm close-btn" @click="handleClose">
            <CloseIcon/>
        </button>
      </div>
      <div class="modal-body">
        <form class="modal-form">
            <div class="mb-1 m-control">
            <label class="form-label">Job Title</label>
                <input type="text" class="form-control" v-model="vacancy.jobTitle" placeholder="General Manager, Assistant etc.">
            </div>
            <div class="mb-1 m-control">
                <label class="form-label">Location</label>
                <select class="form-control" v-model="vacancy.location">
                    <option value="" selected>Select a Job Location</option>
                    <option v-for="district in pagecontent.districts" :value="district">{{ district }}</option>
                </select>
            </div>
            <div class="mb-3 m-control">
                <label class="form-label">Closing Date</label>
                <input type="date" v-model="vacancy.closingDate" class="form-control">
            </div>
            <div class="mb-3 m-control">
                <label class="form-label">Job Type</label>
                <select class="form-control"  v-model="vacancy.jobType">
                    <option value="" selected>Select a Job Type</option>
                    <option v-for="jobtype in pagecontent.jobTypes" :value="jobtype">{{ jobtype }}</option>
                </select>
            </div>
            <div class="mb-1 m-control">
                <div ref="addEditor" class="custom-quill"></div>
            </div>

        </form>
         <!-- errors -->
        <div class="errors" v-if="hasErrors" style="margin-top:1rem;">
            <div class="error" v-for="error in errors">{{ error }}</div>
        </div>
        <!-- errors -->  
      </div>
      <div class="completed" v-if="completed">
        <div class="completed-message">You have successfully added a new vacancy.</div>
        <button v-if="isVacanciesPage" class="btn btn-default btn-sm completed-link" @click="seeVacancies">See Vacancies</button>
      </div>
      <LoadingIndicator v-if="loading"/>
      <div class="modal-footer" v-else>
        <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
        <button type="button" @click="addVacancy" class="btn btn-primary" style="color:white;background:var(--tertiary);border:0px;">{{saveButtonLabel}}</button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import Quill from 'quill'
import 'quill/dist/quill.snow.css'
import {Modal} from 'bootstrap';
import LoadingIndicator from '../Utility/LoadingIndicator.vue';
import { addVacancyAsync } from '@/services/employers/vacancyService';
import router from '@/router';
import pagecontent from '@/assets/text.json'
import CloseIcon from '../IconComponents/CloseIcon.vue';
export default {
    components:{
        LoadingIndicator, CloseIcon
    },
    props:{
        modalTitle:{
            type: String,
            required: true
        },
        saveButtonLabel:{
            type: String,
            required: true
        },
        closeAndRedirect:{
            type: Function,
            required: true
        },
        modalId:{
            type:String,
            required: true
        }
    },
    data(){
        return{
            pagecontent,
            vacancy:{
                jobTitle:"",
                location:"",
                description:"",
                closingDate:"",
                jobType:"",
                isVacanciesPage: false
                
            },
            errors:[],
            loading:false,
            hasErrors:false,
            completed:false
        }
    },
    mounted(){
        this.modalInstance = new Modal(this.$refs.addVacModalEl);
        this.setupQuill();
    },
    methods:{
         handleClose() {
            this.hide();

            if(this.$route.name == 'enterprise-vacancies'){
                this.$router.go(0);
            }
        // if (typeof this.closeModal === 'function') {

        // }
        },
         show() {
            this.modalInstance?.show();
        },
        hide(){
            this.modalInstance?.hide();
        },
        seeVacancies(){
            if(typeof this.closeAndRedirect === 'function'){
                this.closeAndRedirect();
            }
        },
        checkIfUserIsOnVacanciesPage(){
            if(this.$route.name != 'enterprise-vacancies'){
                this.isVacanciesPage = true;
            }else{
                this.isVacanciesPage = false;
            }
        },
        async addVacancy(){
            try{
            this.loading = true;
            this.completed = false;
            this.hasErrors = false;
            this.errors = [];
            if(this.vacancy.closingDate != ""){
            this.vacancy.closingDate = this.formatDateForInput(this.vacancy.closingDate);
            }else{
                throw new Error("Please provide a closing date")
            }
            
            var response = await addVacancyAsync(this.vacancy, () => this.hide());
            if(!response.success){
                this.loading = false;
                    if(!response.errors){
                        const err = new Error(response.message, {reason: response.caption});
                        err.caption = response.caption;
                        throw err;
                    }else{
                        this.errors = response.errors;
                        this.hasErrors = true
                    }
                }else{
                    this.checkIfUserIsOnVacanciesPage();
                    this.loading = false;
                    this.completed = true;
                     this.vacancy = {
                        jobTitle:"",
                        location:"",
                        description:"",
                        closingDate:"",
                        jobType:""        
                    };
                    // Clear the Quill editor
                    this.quill.setContents([]);
                    setTimeout(() => this.completed = false, 5000);
                }
            }catch(e){
                this.errors.push(e.message);
                this.hasErrors = true;
                this.loading = false;
                this.completed = false;
            }
        },
         formatDateForInput(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return '';
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        setupQuill(){
                // Initialize Quill
            this.quill = new Quill(this.$refs.addEditor, {
            theme: 'snow',
            modules: {
                toolbar: [
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' },
                 { list: 'bullet' }],
                ['link']
                ]
            }
            });
            //set present values
            this.quill.root.innerHTML = this.vacancy.description;

            // Listen for changes and update Vue data
            this.quill.on('text-change', () => {
            this.vacancy.description = this.quill.root.innerHTML
            })
    }
    }
}
</script>
<style scoped>

    .completed-link{
        background-color: var(--page-header);
        border:0px;
        color:white;    
    }

    .completed-link:hover{
        border:1px solid white;
    }
    .completed{
        display: flex;
        justify-content: space-between;
        align-items: center;
        color:var(--page-header);
        background-color: var(--background);
        margin-left:1rem;
        margin-right:1rem;
        margin-bottom:0.5rem;
        padding:0.2rem 0.3rem;
        border-radius: 8px;
        font-size:0.9rem;
    }

    input, label{
        font-size:0.9rem;
    }
    .modal-form{
        display: grid;
        column-gap:1rem;
        grid-template-columns: repeat(2,1fr);
        grid-template-rows: repeat(4,auto);
    }

    .m-control:nth-child(3){
        grid-column:1/2;
    }
    .m-control:last-child{
        grid-column:1/3;
    }
      /* MODAL */
    .modal-body{
        color:var(--foreground);
    }

   

    .modal-header{
      border-bottom:0px;
    }

    
</style>